const exportTranscript = (axios, email) => {
  return axios.post('transcripts', { email });
};

export { exportTranscript };
